import { format, isValid, parseISO } from "date-fns";


export const formatDateFromString = (dateString: string) => {
    // Parse the date string into a Date object
    const date = parseISO(dateString);
    // Format the date as 'MM/dd/yyyy'. You can adjust the format string as needed.
    return format(date, 'MM/dd/yyyy');
};

export const formatDateFromStringWithHour = (dateString: string) => {
    // Parse the date string into a Date object
    const date = parseISO(dateString);
    // Format the date as 'MM/dd/yyyy'. You can adjust the format string as needed.
    return format(date, 'd MMM yyyy, HH:mm:ss');
};

export const formatTimeAgoFromString = (dateString?: string | null) => {
    if (!dateString) return 'N/A';

    const date = parseISO(dateString);

    if (!isValid(date)) return 'N/A';

    const diff = Date.now() - date.getTime();
    const absDiff = Math.abs(diff);
    const suffix = diff >= 0 ? 'ago' : 'from now';
    const units = [
        { value: 365 * 24 * 60 * 60 * 1000, label: 'y' },
        { value: 30 * 24 * 60 * 60 * 1000, label: 'mo' },
        { value: 7 * 24 * 60 * 60 * 1000, label: 'w' },
        { value: 24 * 60 * 60 * 1000, label: 'd' },
        { value: 60 * 60 * 1000, label: 'h' },
        { value: 60 * 1000, label: 'min' },
    ];

    const unit = units.find((item) => absDiff >= item.value);

    if (!unit) return 'just now';

    return `${Math.floor(absDiff / unit.value)}${unit.label} ${suffix}`;
};

export const formatDateFromDate = (date: Date) => {
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const month = monthNames[date.getMonth()];
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure two digits
    const seconds = date.getSeconds().toString().padStart(2, '0'); // Ensure two digits
  
    return `${day} ${month} ${hours}:${minutes}.${seconds}`;
}
